module.exports = __webpack_public_path__ + "img/vartext1en.a6d8bb7b.svg";